<template>
  <v-container px-0>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <div class="headline my-1">Student Accounts</div>
      </v-flex>
      <v-flex xs12 my-3 body-3>
          Students share generic accounts (they will <strong>not</strong> have individual accounts). This makes student setup incredibly easy and eliminates privacy concerns. Students select the Sign In link from the website and enter details from below. Passwords are case-sensitive.
      </v-flex>
      <v-flex xs12 my-3 display-1 text-xs-center text--secondary v-if="loading">
        <v-progress-circular
          indeterminate
          large
          color="secondary"
        ></v-progress-circular>
      </v-flex>
      <v-flex xs12 v-if="!loading && hasClassroomLicense">
        <v-layout wrap justify-center>
          <v-flex xs12 mt-3 v-if="isAdmin && inSchool">
            <img src="@/assets/schoolwide_icon.png" style="vertical-align: bottom; margin-right: 16px; height: 48px;"/><span class="headline">Schoolwide</span>
            <p class="body-3 my-3">A generic account for all students in the school to share. All teachers see these and can share with their students, but only the license Administrator can create or edit them.</p>
          </v-flex>
          <v-flex xs12 mt-3 v-if="!isAdmin && inSchool">
            <img src="@/assets/schoolwide_icon.png" style="vertical-align: bottom; margin-right: 16px; height: 48px;"/><span class="headline">Schoolwide</span>
            <p class="body-3 my-3">A generic account for all students in the school to share. All teachers see these and can share with their students, but only the license Administrator can create or edit them.</p>
          </v-flex>
          <v-flex xs12 v-if="inSchool">
            <SchoolwideClasses/>
          </v-flex>
          <v-flex xs12 mt-3 v-if="isAdmin">
            <img src="@/assets/classwide_icon.png" style="vertical-align: bottom; margin-right: 16px; height: 48px;"/><span class="headline">My Students</span>
            <p class="body-3 my-3">A generic account for all your students to share. If you teach multiple classes you can create a separate shared generic account for each class, or use the same generic account across all your classes.</p>
          </v-flex>
          <v-flex xs12 mt-3 v-if="!isAdmin">
            <img src="@/assets/classwide_icon.png" style="vertical-align: bottom; margin-right: 16px; height: 48px;"/><span class="headline">My Students</span>
            <p class="body-3 my-3">A generic account for all your students to share. If you teach multiple classes you can create a separate shared generic account for each class, or use the same generic account across all your classes.</p>
          </v-flex>
          <v-flex xs12>
            <Classes/>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs8 pa-3 elevation-3 text-xs-center title v-else>
        <v-alert
          :value="true"
          color="secondary"
          icon="info"
          outline
        >
          You need an active Class license to created student accounts.
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Classes from '@/components/Classes'
import SchoolwideClasses from '@/components/SchoolwideClasses'
import ClassroomService from '@/services/ClassroomService'

export default {
  components: {
    Classes,
    SchoolwideClasses
  },
  data: function () {
    return {
      loading: false,
      hasClassroomLicense: false,
      classrooms: []
    }
  },
  mounted: function () {
    this.loadClassrooms();
  },
  methods: {
    async loadClassrooms () {
      this.loading = true;
      try {
        const result = await ClassroomService.index();
        this.hasClassroomLicense = true;

        this.classrooms = result.data;
      } catch (err) {
        // they don't have a classroom license
      }

      if (this.hasClassroomLicense) {
        if (this.classrooms.length === 0 && this.isAdmin) {
          this.$router.push({
            path: '/account/new-school-classroom'
          })
        } else if (this.classrooms.length === 0 && !this.isAdmin) {
          // show the first time class creation tutorial for a teacher
          this.$router.push({
            path: '/account/new-classroom'
          })
        } else {}
      }

      this.loading = false;
    },
  },
  computed: {
    isAdmin: function () {
      if (this.$store.getters.user) {
        return this.$store.getters.user.isAdminUser
      }
      return false
    },
    inSchool: function () {
      if (this.$store.getters.user) {
        return this.$store.getters.user.schoolId !== null
      }
      return false
    }
  }
}
</script>

<style scoped>
.description-cell {
  min-height: 48px;
}
</style>
